import { MessageSquare, ExternalLink, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const WhatsApp = () => {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-6 py-10 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-4xl font-semibold text-foreground mb-2 tracking-tight">
            WhatsApp Member Chat
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base tracking-wide">
            Connect with fellow executives in real-time
          </p>
        </div>

        <Card className="mb-6">
          <CardContent className="pt-6 space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                <MessageSquare className="w-6 h-6 text-green-600" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold mb-2">ETP Member WhatsApp Group</h3>
                <p className="text-sm text-muted-foreground">
                  Join the private ETP member WhatsApp group to stay connected between events.
                </p>
              </div>
            </div>
            <Button size="lg" className="w-full sm:w-auto" asChild>
              <a
                href="https://chat.whatsapp.com/JqGIng19LUs1WmtSzIiYro"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageSquare className="w-4 h-4 mr-2" />
                Open WhatsApp Chat
                <ExternalLink className="w-4 h-4 ml-2" />
              </a>
            </Button>
          </CardContent>
        </Card>

        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Chat Guidelines</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                1
              </div>
              <div>
                <h4 className="font-semibold text-sm mb-1">Stick to energy-related content</h4>
                <p className="text-sm text-muted-foreground">
                  Focus discussions on energy industry and energy policy
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                2
              </div>
              <div>
                <h4 className="font-semibold text-sm mb-1">Keep it confidential</h4>
                <p className="text-sm text-muted-foreground">
                  What's shared in the group stays in the group
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                3
              </div>
              <div>
                <h4 className="font-semibold text-sm mb-1">Avoid sales pitches</h4>
                <p className="text-sm text-muted-foreground">
                  Feel free to discuss your latest projects, but avoid explicit promotional content
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-muted/50">
          <CardContent className="pt-6">
            <div className="flex items-start gap-3">
              <Users className="w-5 h-5 text-muted-foreground mt-0.5" />
              <div>
                <h4 className="font-semibold mb-1">Active Community</h4>
                <p className="text-sm text-muted-foreground">
                  The ETP Member WhatsApp Group typically sees 3-5 messages per day, with most discussion centering around the latest energy market and policy developments, plus regular updates from the ETP team on upcoming calls and events. Contact <a href="mailto:michelle@alexepstein.com" className="text-primary hover:underline">michelle@alexepstein.com</a> with any questions.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WhatsApp;
